import React from 'react';

import { DeviceGalleryQuery } from '__generated__/DeviceGalleryQuery.graphql';
import { BrandProps, ColorProps } from '../../typings';
import Filters from './Filters';

interface FiltersTopSectionProps extends BrandProps, ColorProps {
  selectedSubcategoryId: string;
  onSelectSubcategoryId: (subcategoryId: string) => void;
  subcategories: DeviceGalleryQuery['response']['deviceGallery']['subcategories'];
  onShowAll: () => void;
}

const FiltersTopSection = ({
  selectedSubcategoryId,
  onSelectSubcategoryId,
  subcategories,
  brandOptions,
  selectedBrandOptions,
  onBrandChange,
  colorOptions,
  selectedColorOptions,
  onColorChange,
  onShowAll,
}: FiltersTopSectionProps) => {
  const selectedSubcategoryName = subcategories.find(
    (subcategory) => subcategory.categoryId === selectedSubcategoryId,
  )?.name;

  return (
    <Filters
      subcategories={subcategories}
      onSelectSubcategoryId={onSelectSubcategoryId}
      selectedSubcategoryId={selectedSubcategoryId}
      selectedSubcategoryName={selectedSubcategoryName}
      brandOptions={brandOptions}
      selectedBrandOptions={selectedBrandOptions}
      onBrandChange={onBrandChange}
      colorOptions={colorOptions}
      selectedColorOptions={selectedColorOptions}
      onColorChange={onColorChange}
      onShowAll={onShowAll}
    />
  );
};

export default FiltersTopSection;
